<template>
    <div v-if="txt" :class="type?'success toast':'error toast'">
      {{ txt }}
    </div>
</template>
<script setup>
    import { ref , computed , watch } from 'vue';
    import { useAlertStore } from '@/stores/alert'
    const alertStore = useAlertStore()
    const type = ref(false) 
    const txt = ref('') 
    const t=computed(()=>{ return alertStore.type })
    const tx=computed(()=>{ return alertStore.msg })
    watch(tx,(val)=>{
        if(val !== ''){
            txt.value = val
            alertStore.msg = ''
            setTimeout(() => ( txt.value = '' ), 3000)
        }
    })
    watch(t,(val)=>{
        if(val) {
            type.value=val
            alertStore.type = false
            setTimeout(() => ( type.value = false ), 3000)
        }
    })
</script>
<style scoped>
    .toast {
        position: fixed;
        bottom: 70px;
        left: 20px;
        color: white;
        padding: 10px 20px;
        border-radius: 8px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }
    .success{
        background: #2ecc71;
    }
    .error{
        background: #cc332e;
    }
</style>